import { Shader3D } from "../../RenderEngine/RenderShader/Shader3D";
import { LayaGL } from "../../layagl/LayaGL";
export class ShaderCompileDefineBase {
    constructor(owner, name, compiledObj) {
        this._owner = owner;
        this.name = name;
        this._VS = compiledObj.vsNode;
        this._PS = compiledObj.psNode;
        this._defs = compiledObj.defs;
        this._validDefine = LayaGL.unitRenderModuleDataFactory.createDefineDatas();
        for (let k of compiledObj.defs)
            this._validDefine.add(Shader3D.getDefineByName(k));
        this._validDefine.add(Shader3D.getDefineByName("VBONEW"));
        this._validDefine.add(Shader3D.getDefineByName("VBONEI"));
    }
    withCompile(compileDefine) {
        return null;
    }
}
